import * as zod from 'zod';

export const RobotiqObjectStateEnum = zod.enum([
  'unknown',
  'detected',
  'atTarget',
]);
export type RobotiqObjectState = zod.infer<typeof RobotiqObjectStateEnum>;

export const RobotiqFaultSeverityEnum = zod.enum([
  'none',
  'minor',
  'major',
  'priority',
]);
export type RobotiqFaultSeverity = zod.infer<typeof RobotiqFaultSeverityEnum>;

export const RobotiqFaultSchema = zod.object({
  code: zod.number(),
  severity: RobotiqFaultSeverityEnum,
  message: zod.string().optional(),
});
export type RobotiqFault = zod.infer<typeof RobotiqFaultSchema>;

export const RobotiqBaseStateSchema = zod.object({
  activated: zod.boolean(),
  busy: zod.boolean(),
  object: RobotiqObjectStateEnum,
  fault: RobotiqFaultSchema.nullable(),
  isConnected: zod.boolean(),
  lastUpdatedAt: zod.number().nullable(),
});
export type RobotiqBaseState = zod.infer<typeof RobotiqBaseStateSchema>;
